import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React from 'react';
import { connect } from "react-redux";
import { withNamespaces } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import Transactions from './List.js'

export class TabContainer extends React.Component{
    render(){  
        const { t } = this.props

        let stil = {wordBreak : "normal"}
        if(isMobile){
            stil = {
                wordBreak : "normal",
                width: "fit-content"
            }
        }

        return(
            <div className="dashboardTabs">
                <Tabs>
                    <TabList>
                        <Tab style={stil}>{t('Transactions')}</Tab>
                    </TabList>
                    <hr className="p-0 m-0" />
                    <TabPanel>
                        <Transactions />
                    </TabPanel>
                </Tabs>
            </div>
        )
    };
};

const mapStateToProps = state => {
    return {      
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(TabContainer));
